import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '../../button-new';
import chevron from '../../../../assets/images/icons/arrow/chevron.svg';
import { useStyles } from './modal-back-button.styles';

export const ModalBackButton = ({ onClick }: { onClick: Function }): JSX.Element => {
  const classes = useStyles();

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
      <Button
        rootClasses={classes.root}
        textClasses={classes.text}
        style="text"
        onClick={handleClick}
        startIcon={<img className={classes.icon} src={chevron} width={24} height={24} alt="" />}
      >
        <FormattedMessage id="common.backButton.label" />
      </Button>
  );
};
